module.exports = __webpack_public_path__ + "img/img151_17.6fe8ca9c.png";